<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-end">
        <b-button
          v-if="isCommonAdmin"
          variant="primary"
          size="lg"
          :disabled="!team.name || !team.description || !selectedList.length || !operationalArea"
          @click="saveTeam"
        >
          {{ this.$route.params.id ? 'save' : 'create' | i18n }}
        </b-button>
      </div>
      <div class="row poppins">
        <div class="col-12">
          <div class="main-wrapper">
            <Loader v-if="!teamLoaded" />
            <div v-else>
              <div class="inputs-block">
                <BlockHeader name="Details" />
                <div class="row">
                  <div class=" col-lg-4 col-sm-12 col-xs-12">
                    <Input v-model="team.name" form-group-id="name" placeholder="name" required customID="TeamName" />
                  </div>
                  <div class=" col-lg-4 col-sm-12 col-xs-12">
                    <Input v-model="team.description" form-group-id="description" placeholder="description" required customID="Description" />
                  </div>
                  <div class=" col-lg-4 col-sm-12 col-xs-12">
                    <Select
                      v-model="operationalArea"
                      :options="operationalAreaList"
                      placeholder="Operational Area"
                      required
                      customID="OperationArea"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class=" col-lg-4 col-sm-6 col-xs-6" v-if="isAVGProject">
                    <Select
                      v-model="shiftLeader1"
                      :options="shiftLeaders1"
                      form-group-id="Shift Leader 1"
                      placeholder="Shift Leader 1"
                      customID="ShiftLeader1"
                    />
                  </div>
                  <div class=" col-lg-4 col-sm-6 col-xs-6" v-if="isAVGProject">
                    <Select
                      v-model="shiftLeader2"
                      :options="shiftLeaders2"
                      form-group-id="Shift Leader 2"
                      placeholder="Shift Leader 2"
                      customID="ShiftLeader2"
                    />
                  </div>
                  <div class=" col-lg-4 col-sm-6 col-xs-6" v-if="isAVGProject">
                    <Select
                      v-model="shiftLeader3"
                      :options="shiftLeaders3"
                      form-group-id="Shift Leader 3"
                      placeholder="Shift Leader 3"
                      customID="ShiftLeader3"
                    />
                  </div>
                </div>
              </div>
              <div class="inputs-block">
                <div class="row">
                  <div class=" col-lg-8 col-sm-12 col-xs-12">
                    <BlockHeader name="Employees" />
                  </div>
                  <div class=" col-lg-4 col-sm-12 col-xs-12" style="display: flex;justify-content: flex-end;align-items: center;">
                    <AddUser :onSave="setSelectedList" :selectedUsers="selectedList" />
                    <b-button variant="primary" size="sm" v-if="isCommonAdmin" v-b-modal.addTeamUser>
                      {{ 'Add Employee' | i18n }}
                    </b-button>
                  </div>
                  <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
                    <div class="table-wrapper" v-if="positionLoaded">
                      <Table
                        :clickHighlight="false"
                        :columns="columns"
                        :rows="selectedList"
                        :filter="{}"
                        :loading-instance="loadingInstance"
                        :set-loading-instance="setLoadingInstance"
                        :pagination="false"
                        tableName="teamDetailsTable"
                      />
                    </div>
                    <div v-else style="width:100%;display:flex;justify-content:center">
                      {{ 'Select Operational Area' | i18n }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DeleteRowMixin, NotificationMixin, AuthMixin, LicenseMixin } from '../../../../mixins';
import api from '../../../api';
import Notification from '../../common/notification';

import PageHeader from '../../common/page-header';
import BlockHeader from '../../common/block-header';

import Loader from '../../common/loader';
import Input from '../../common/input';
import Multiselect from '../../common/multiselect';
import Select from '../../common/select';
import Table from '../../common/table';
import AddUser from './add-user';
import hash from 'object-hash';

export default {
  title: 'Team Details',
  components: { PageHeader, Loader, BlockHeader, Input, Multiselect, Select, Table, AddUser },
  mixins: [DeleteRowMixin, NotificationMixin, AuthMixin, LicenseMixin],
  beforeRouteLeave(to, from, next) {
    const modified = Object.values(this.team).length;
    if (this.disablePrevent || !modified) {
      return next();
    }

    let updated1 = ['description', 'name'].some(k => {
      return this.initTeam[k] !== this.team[k];
    });

    let updated2 = ['shiftLeader1', 'shiftLeader2', 'shiftLeader3'].some(k => {
      console.log(this.initTeam[k], this[k], 'mmmm');
      return this.initTeam[k] !== this[k];
    });

    if (
      hash(this.team.users || {}) !== hash(this.initTeam.users || {}) ||
      hash(this.selectedList || {}) !== hash(this.initSelectedList || {}) ||
      hash(this.initShiftPositionsUser || {}) !== hash(this.shiftPositionsUser || {}) ||
      hash(this.initStartWorkingDate || {}) !== hash(this.startWorkingDate || {}) ||
      hash(this.initUserOrder || {}) !== hash(this.userOrder || {})
    ) {
      updated1 = true;
    }
    if (!updated1 && !updated2) {
      return next();
    }
    const answer = window.confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  data() {
    return {
      disablePrevent: false,
      teamLoaded: false,
      positionLoaded: false,
      team: {},
      initTeam: {},
      userOptions: [],
      users: [],
      selectedList: [],
      shiftPositions: [],
      shiftPositionsObj: {},
      shiftPositionsUser: {},
      startWorkingDate: {},
      userOrder: {},
      shiftLeader1: null,
      shiftLeader2: null,
      shiftLeader3: null,
      operationalArea: null,
      operationalAreaList: null,
      userObj: {},
      loadingInstance: null,
      columns: [
        {
          field: 'user',
          title: this.$translate('Employee'),
          key: '1',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return (
              <div>
                {row.name} ({row.email})
              </div>
            );
          }
        },
        {
          field: 'order',
          title: 'Order',
          key: '2',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return (
              <div class="wrapper">
                <label class="input-label input-label-focus">{this.$translate('Order')}</label>
                <input
                  type="text"
                  class="date-input"
                  value={this.userOrder[row.id]}
                  onChange={e => {
                    this.userOrder[row.id] = e.target.value;
                  }}
                />
              </div>
            );
          }
        },
        {
          field: 'startWorkingDate',
          title: 'Start working date',
          key: '3',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return (
              <div class="wrapper">
                <label class="input-label input-label-focus">{this.$translate('Start working date')}</label>
                <input
                  type="date"
                  class="date-input"
                  value={this.startWorkingDate[row.id]}
                  onChange={e => {
                    this.startWorkingDate[row.id] = e.target.value;
                  }}
                />
              </div>
            );
          }
        },
        {
          field: 'shiftPosition',
          title: this.$translate('Shift Position'),
          key: '4',
          align: 'left',
          width: 300,
          renderBodyCell: ({ row, column }) => {
            return (
              <div class="wrapper">
                <label class="input-label input-label-focus">{this.$translate('Shift Position')}</label>
                <select
                  value={this.shiftPositionsUser[row.id]}
                  onChange={e => {
                    this.shiftPositionsUser[row.id] = e.target.value;
                  }}
                  class="select-box input"
                >
                  <option value="" selected>
                    {this.$translate('Select Shift Position')}
                  </option>
                  {this.shiftPositions.map(i => (
                    <option value={i.value}>
                      {i.text} {i.operationalArea ? `(${i.operationalArea.map(o => this.$translate(o.name)).join(', ')})` : ''}
                    </option>
                  ))}
                </select>
              </div>
            );
          }
        },
        {
          field: 'actions',
          title: '',
          key: '5',
          width: 50,
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                <div class="delete-button" on-click={() => this.deleteUser(row)}>
                  {this.$translate('Delete')}
                </div>
              </div>
            );
          }
        }
      ]
    };
  },
  async created() {
    await this.getTeam();
  },
  computed: {
    shiftLeaders1: function() {
      const array = [this.shiftLeader2, this.shiftLeader3];
      return this.filteredSelectedUsers(array);
    },
    shiftLeaders2: function() {
      const array = [this.shiftLeader1, this.shiftLeader3];
      return this.filteredSelectedUsers(array);
    },
    shiftLeaders3: function() {
      const array = [this.shiftLeader1, this.shiftLeader2];
      return this.filteredSelectedUsers(array);
    }
  },
  watch: {
    async operationalArea(newVal) {
      if (newVal) {
        this.positionLoaded = false;
        const positions = await api.shiftPositions.get({ operationalArea: newVal });
        this.shiftPositionsObj = {};
        this.shiftPositions = positions.map(i => {
          this.shiftPositionsObj[i.id] = i;
          return { value: i.id, text: i.name, operationalArea: i.operationalArea };
        });
        this.positionLoaded = true;
      }
      return [];
    }
  },
  methods: {
    async deleteUser(user) {
      await this.deleteSelectedRows(
        null,
        () => {
          this.selectedList = this.selectedList.filter(u => u.id !== user.id);
        },
        false
      );
    },
    filteredSelectedUsers(array) {
      const filtered = this.selectedList.filter(v => {
        if (!array.includes(v.id)) {
          return true;
        }
        return false;
      });
      return filtered.map(v => ({ value: v.id, text: v.name }));
    },
    setSelectedList(user) {
      this.selectedList.push({
        name: user.username,
        email: user.email,
        id: user.id
      });
      const ids = this.selectedList.map(u => u.id);
      if (!ids.includes(this.shiftLeader1)) {
        this.shiftLeader1 = null;
      }
      if (!ids.includes(this.shiftLeader2)) {
        this.shiftLeader2 = null;
      }
      if (!ids.includes(this.shiftLeader3)) {
        this.shiftLeader3 = null;
      }
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    async saveTeam() {
      try {
        const shiftPositions = {};
        const startWorkingDate = {};
        const userOrder = {};
        const userIds = this.selectedList.map(u => {
          if (this.shiftPositionsUser[u.id]) {
            shiftPositions[u.id] = this.shiftPositionsUser[u.id];
          }
          if (this.startWorkingDate[u.id]) {
            startWorkingDate[u.id] = this.startWorkingDate[u.id];
          }
          if (this.userOrder[u.id]) {
            userOrder[u.id] = this.userOrder[u.id];
          }
          return u.id;
        });

        const payload = {
          name: this.team.name,
          description: this.team.description,
          shiftPositions,
          startWorkingDate,
          userOrder,
          userIds,
          operationalArea: this.operationalArea
        };
        if (this.isAVGProject) {
          payload.shiftLeader1 = this.shiftLeader1;
          payload.shiftLeader2 = this.shiftLeader2;
          payload.shiftLeader3 = this.shiftLeader3;
        }

        if (this.$route.params.id) {
          await api.teams.updateTeam(this.$route.params.id, payload);
        } else {
          await api.teams.createTeam(payload);
        }
        Notification({ type: 'success', message: this.$translate('success') });
        this.disablePrevent = true;
        this.$router.go(-1);
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      }
    },
    async getTeam() {
      try {
        this.teamLoaded = false;
        const operationalAreas = await api.operationalArea.get();
        this.operationalAreaList = operationalAreas.map(o => ({ value: o.id, text: o.name }));
        let responseTeam;
        if (this.$route.params.id) {
          responseTeam = await api.teams.getTeamByID(this.$route.params.id);
          this.team = responseTeam.data;
          this.operationalArea = responseTeam.data.operationalArea;

          if (responseTeam.data.shiftLeader1) {
            this.shiftLeader1 = responseTeam.data.shiftLeader1.id;
          }
          if (responseTeam.data.shiftLeader2) {
            this.shiftLeader2 = responseTeam.data.shiftLeader2.id;
          }
          if (responseTeam.data.shiftLeader3) {
            this.shiftLeader3 = responseTeam.data.shiftLeader3.id;
          }

          this.selectedList = responseTeam.data.users ? responseTeam.data.users : [];
        }

        const response = await api.teams.getUsersLookup();
        this.users = response.data;
        this.users.forEach(u => {
          this.userObj[u.id] = u;
          if (this.$route.params.id) {
            const teamUser = responseTeam.data.users.find(t => t.id === u.id);
            if (teamUser) {
              if (teamUser.shiftPosition && teamUser.shiftPosition.id) {
                this.shiftPositionsUser[teamUser.id] = teamUser.shiftPosition.id;
              }
              if (teamUser.startWorkingDate) {
                this.startWorkingDate[teamUser.id] = teamUser.startWorkingDate;
              }
              if (teamUser.order) {
                this.userOrder[teamUser.id] = teamUser.order;
              }
            }
          }
        });

        this.initSelectedList = JSON.parse(JSON.stringify(this.selectedList));
        this.initTeam = JSON.parse(JSON.stringify(this.team));
        this.initTeam.shiftLeader1 = this.shiftLeader1;
        this.initTeam.shiftLeader2 = this.shiftLeader2;
        this.initTeam.shiftLeader3 = this.shiftLeader3;
        this.initShiftPositionsUser = JSON.parse(JSON.stringify(this.shiftPositionsUser));
        this.initStartWorkingDate = JSON.parse(JSON.stringify(this.startWorkingDate));
        this.initUserOrder = JSON.parse(JSON.stringify(this.userOrder));
        this.teamLoaded = true;
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.checkbox {
  height: 31px;
  display: flex;
  align-items: center;
  label {
    margin-bottom: 0 !important;
  }
  label::before {
    margin-top: 2px;
  }
  label::after {
    margin-top: 2px;
  }
}

.main-content {
  min-height: calc(100vh - 120px);
  overflow-x: hidden;
}

.header-box {
  width: 100%;
  border: 1px solid black;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  height: 40px;
  align-items: center;
}
.box-border {
  border: 1px solid black;
  text-align: center;
  margin: 0 10px 10px 0;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-wrapepr {
  display: flex;
}

.select-box {
  outline: none;
  border: none;
  cursor: pointer;
  width: 100%;

  color: #495057;
  background-color: #fff;
  height: 32px !important;
  box-shadow: none !important;
  outline: 0;
  border-color: #80bdff;

  border-radius: 0.2rem !important;
  border: 1px solid #ced4da;

  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  display: inline-block;
  width: 100%;

  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/8px 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.select-wrapper {
  padding: 0 10px;
}

.action-box-size {
  height: 40px;
  margin: 0 10px 10px 0;
  button {
    width: 100%;
    height: 100%;
  }
}

.action-box {
  background: #2260ff;
  color: white;
  cursor: pointer;
  height: 40px;
  margin: 0 10px 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-with-btn {
  padding: 0;
}

.user-box {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
}
.user-box-email {
  font-size: 9px;
  color: #c7c7c7;
}

.user-box:hover .user-box-delete {
  opacity: 1;
  cursor: pointer;
}

.user-box-delete {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #db474f;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  opacity: 0;
  cursor: pointer;
  transition: all 0.5s;
}

.top-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-wrapper {
  margin-top: 10px;
  overflow: hidden;
}

.input-label-focus {
  font-size: 12px !important;
  top: -8px !important;
  line-height: 15px;
}
.input-label-focus-color {
  color: #80bdff !important;
}

.input {
  height: 32px !important;
}

.input-label {
  position: absolute;
  left: 10px;
  color: #80868b;
  top: 6px;
  font-size: 14px;
  background: white;
  padding: 0 5px;
  transition: all 0.2s ease-out;
  z-index: 2;
}

.wrapper {
  display: flex;
  position: relative;
}

::v-deep  .ve-table-cell-selection {
  border-bottom: 1px solid #eee !important;
}

::v-deep  .delete-button {
  background: rgb(219, 71, 79);
  color: white;
  border-color: #db474f;
  border: 2px solid #db474f;
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  cursor: pointer;
}

.date-input {
  height: 32px !important;
  outline: 0;
  border-radius: 0.2rem !important;
  border: 1px solid #ced4da;
  padding: 0 10px;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  font-family: 'Poppins', sans-serif;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
